/** The bag piece, standard look over its behavior half: the bag page's, or the drawer a custom page places. */
import type { PieceInput } from '../../contract/runtime';
import type { ShopBagEvents } from './contract';
import { ShopBagView } from './ShopBagView';
import { useShopBag } from './useShopBag';

export { ShopBagView, useShopBag };

export function ShopBag(props: PieceInput<ShopBagEvents>) {
  return <ShopBagView {...useShopBag(props)} />;
}
